import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React, { useCallback } from "react";
import { DUPLICATION_AMAZON_IDEA, DUPLICATION_AMAZON_IDEAS } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaCtx } from "../context";

export default function AmazonIdeaDuplication({
    open,
    onClose,
    ids,
    onCompleted,
}) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();

    const [setDelay] = useTimeout();
    const [cloneAmazonIdea, { loading }] = useMutation(
        DUPLICATION_AMAZON_IDEAS,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Clone amazon idea successfully",
                    err: false,
                });
                onClose();
                onCompleted && onCompleted();

                setDelay(() => {
                    refetch && refetch();
                }, 1000);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;
        setNotify && setNotify({ msg: null, err: false });
        toggleToast && toggleToast(true);

        const input = [];
        for (let id of ids) {
            input.push({ amazonIdeaID: id });
        }

        cloneAmazonIdea({
            variables: {
                input,
            },
        });
    }, [ids, cloneAmazonIdea, setNotify, toggleToast]);

    return (
        <Modal
            open={open}
            title="Clone Amazon Idea"
            onClose={onClose}
            sectioned
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Clone",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <p>Are you sure to clone this idea?</p>
        </Modal>
    );
}
